import { type Interval, differenceInMilliseconds } from "@suse-o11y/date-time";
import type { Time } from "@suse-o11y/date-time/time";
import clamp from "lodash/clamp";

export interface TimeToPxParams {
	time: Time;
	interval: Interval;
	width: number;

	/**
	 * If true, clamps the pixel value to the range [0, width].
	 *
	 * @default false
	 */
	clamped?: boolean;
}

export function timeToPx({ time, interval: { start, end }, width, clamped = false }: TimeToPxParams): number {
	const duration = differenceInMilliseconds(end, start);

	if (duration === 0) {
		return 0;
	}

	const ratio = width / duration;
	const px = differenceInMilliseconds(time, start) * ratio;

	return clamped ? clamp(px, 0, width) : px;
}
